import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import qs from "query-string"
// require('dotenv').config();
// import dotenv from 'dotenv'

//pass new generated access token here
// const token = accessToken

//apply base url for axios
// REACT_APP_API_URL_QA
// const API_URL = "http://localhost:9000"

const is_api_localhost = process.env.REACT_APP_API_LOCALHOST.toString().trim() === "true"
const is_api_qa = process.env.REACT_APP_API_QA.toString().trim() === "true"

// console.log(process.env.REACT_APP_API_LOCALHOST)
// console.log(process.env.REACT_APP_API_QA)

export const API_URL = is_api_localhost
  ? process.env.REACT_APP_API_URL_LOCALHOST
  : is_api_qa ? process.env.REACT_APP_API_URL_QA
  : window.location.hostname === "crm.advaice.com" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_QA

export const SERVER_POSITION = is_api_localhost
  ? process.env.REACT_APP_API_URL_LOCALHOST
  : is_api_qa ? process.env.REACT_APP_API_URL_QA
  : window.location.hostname === "crm.advaice.com" ? 'prod' : 'dev'

export const axiosApi = axios.create({
  baseURL: API_URL,
})

// axiosApi.defaults.headers.common["Authorization"] = token

export const updateAuthorizationToken = token => {
  axiosApi.defaults.headers.common["Authorization"] = 'JWT ' + token
}

axiosApi.interceptors.response.use(
  response => response,
  // eslint-disable-next-line no-undef
  error => Promise.reject(error)
)

axiosApi.defaults.paramsSerializer = function(params) {
  return qs.stringify(params, { indices: false }); // param=value1&param=value2
}

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, config)
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, data, config)
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
